module.exports = __webpack_public_path__ + "static/media/IMG-3.83cf23c6.jpg";